<template>
    <div id="publication_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Publications</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <router-link v-if="canAddPublication" class="btn btn-primary pull-right" v-bind:to="{name: 'PublicationCreate'}" > <i class="fp-add"> </i> Upload</router-link>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content publication-list">
                        <data-table-filter-config :moduleName="'publicationList'" :removeLineButtonVisibility="false" :addFilterButtonVisibility="false" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'publicationList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listPublications"
                                    mode="remote"
                                    title="Publications"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: deleteBtnAccess,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <a v-if="canViewAuditLog" title="View Log" v-on:click.prevent="goToGetLogInfo(props.row.id,props.row.type)" class="fp-log-file-format" href="javascript:void(0)"></a>
                                                <router-link title="Edit Publication" v-if="props.row.type == 'pub'" class="fp-edit" v-bind:to="{name: 'PublicationEdit',params:{id:props.row.id}}"></router-link>
                                                <router-link title="Edit Campaign" v-else class="fp-edit" v-bind:to="{name: 'CampaignEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else-if="props.column.field == 'link'">
                                                <a v-on:click="goToGetDocumentPath($event, props.row)" title="View Document" href="" style="font-size: 15px;"><i class="fp-text-document"></i></a>
                                            </div>
                                            <div v-else>
                                                {{ props.formattedRow[props.column.field] }}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="deleteBtnAccess" id="deletePublicationBtn" v-on:click.prevent="publicationDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
              <audit-log-popup :logs="logs" :popUpTitle="popUpTitle" :fileFlag="fileFlag"></audit-log-popup>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import EventBus from "../event-bus";
import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
import AuditLogPopUp from "../AuditLogPopUp.vue";
Vue.use(VueGoodTable);
Vue.component("audit-log-popup",AuditLogPopUp);

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import { contractMixins } from '../../mixins/contractMixins';

    export default {
        name: "PublicationList",
        components: {
            customPagination: () => import('@/components/layout/CustomPagination'),
            dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
            clearCacheData: () => import('@/components/ClearCacheData'),
            appFooter: () => import('@/components/Footer'),
        },
        mixins:[commonMixins,dataTableMixins,contractMixins],
        metaInfo() {
            return {title: "Publications | " + process.env.COPYRIGHT_NAME}
        },
        data: () => ({
            permissions: [],
            cantAccessPage: '',
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    filterable: false,
                    hidden: true,
                },
                {
                    label: 'Department',
                    field: 'department',
                    filterable: true,
                    hidden:false,
                    sortable: false,
                    multiple:true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Department", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Document Title',
                    field: 'document_title',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Document Title", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Document Type',
                    field: 'document_type',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    multiple:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Document Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Publication Number',
                    field: 'publication_no',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Publication Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Publication Date',
                    field: 'publication_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Publication Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
              {
                label: 'Revision Date',
                field: 'revised_date',
                fpFieldType:"date",
                hidden:false,
                filterable: true,
                filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Revised Date", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
                },
              },
                {
                    label: 'Documents',
                    field: 'link',
                    sortable: false,
                    filterable: false,
                },
            ],
            rows: [],
            totalRecords: 0,
            deleteBtnAccess: false,
            loading:false,
            canEditPublication:false,
            canEditCampaign:false,
            canAddPublication:false,
            pageKey:"_publication_list_",
            errorMsg: "",
            departmentArr: [],
            documenttypeArr: [],
            canViewAuditLog: false,
            logs: [],
            popUpTitle: "Publication Activity Log Details",
            fileFlag: "publication"

        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    self.cantAccessPage = true;
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'ev_add_publication') {
                            self.canAddPublication = true;
                        }
                        if (permissions[i].name == 'ev_edit_publication') {
                            self.canEditPublication = true;
                        }
                        if (permissions[i].name == 'ev_delete_publication') {
                            self.deleteBtnAccess = true;
                        }
                        if (permissions[i].name == 'ev_edit_campaign') {
                            self.canEditCampaign = true;
                            for (let i = self.columns.length - 1; i >= 0; i--) {
                                if (self.columns[i].label == 'Actions') {
                                    self.columns[i].hidden = false;
                                    break;
                                }
                            }
                        }
                      if (permissions[i].name == 'ev_view_log_publication') {
                        self.canViewAuditLog = true;
                      }
                    }
                }
            },
        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            self.loadFieldData(['publication_depart_doc_type']);
        },
        methods: {
            cancelAll: function () {
              this.$refs.listPublications.unselectAllInternal();
            },

            selectionChanged(param) {
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                $.ajax({
                    url: process.env.ROOT_API + "/publication/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {                            
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'publication-list');
                    }
                });
            },
            publicationDelete(){
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this publication?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var data = this.$refs['listPublications'].selectedRows;
                        var use = [];
                        for (var i = 0; i < data.length; i++) {
                            use.push(this.$refs['listPublications'].selectedRows[i].id)
                        }
                        self.loading = true;
                        $("#deletePublicationBtn").val("Deleting ...");
                        $.ajax({
                          url: process.env.ROOT_API + "/publication/delete",
                          type: "POST",
                          data: 'ids=' + use,
                          headers: this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              setTimeout(function () {
                                  $("#deletePublicationBtn").val("Delete");
                              }, 1000);
                              if (data.code == '200') {
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    self.$router.push("/");
                                }
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 5000);
                            }
                          }
                      });
                    }
                });
            },
            goToGetDocumentPath(event, row){
                event.preventDefault();
                var self = this;
                var path = row.link;
                var flag = '';
                var id = 0;
                if(row.id > 0){
                    id = row.id;
                    if(row.type == 'pub'){
                        flag = 'publication';
                    }else{
                        flag = 'campaign';
                    }
                }
                self.getDocumentPath(id, path, flag);
            },
          goToGetLogInfo(logId,rowType){
            var self = this;
            if(rowType == "pub"){
              var logFlag = 'PUBLICATION_AUDIT';
              self.popUpTitle = "Publication Activity Log Details";
              self.fileFlag = "publication";
            }else{
              var logFlag = 'CAMPAIGN_AUDIT';
              self.popUpTitle = "Campaign/Recall Activity Log Details";
              self.fileFlag = "campaign";
            }

            self.getLogInfo(logId, logFlag);
          },
        }
    };
</script>
<style scoped>
.data-table table.vgt-table .fp-log-file-format {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/publication/PublicationList.vue